<p-fieldset [legend]="'EXPRESS_CONFIG.TITLE' | translate">
  <div class="grid">
    <div class="col-10 flex flex-row align-items-center">
      <div class="col-1">
        <p-inputSwitch [(ngModel)]="enableForAll"></p-inputSwitch>
      </div>
      <div class="col-11">
        <span>{{('EXPRESS_CONFIG.SWITCH_LABEL' | translate) + " " + currentUser.idCustomer}}</span>
      </div>
    </div>
    <div class="col-2 flex flex-row align-items-center">
      <button pButton type="button" [icon]="'fa fa-key'" [label]="'COMMON.SAVE' | translate"
              (click)="saveExpressConfig()" class="p-button-warning"></button>
    </div>
    <div class="col-12" *ngIf="!enableForAll">
      <div *ngIf="!customerIDs || customerIDs.length === 0">
        <span>{{'EXPRESS_CONFIG.NO_ANALYTIC_ID'| translate}}</span>
      </div>
      <div *ngIf="customerIDs && customerIDs.length > 0">
        <p-pickList [source]="availableIDs" [target]="selectedIDs"
        [sourceHeader]="'CL existants'" [targetHeader]="'CL sélectionnés'"
        [showSourceControls]="false" [showTargetControls]="false">
          <ng-template pTemplate="item" let-cl>
            <div>{{cl}}</div>
          </ng-template>
        </p-pickList>
      </div>
    </div>
  </div>
</p-fieldset>
